import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { SmartAllocationTypes } from "@/app/smart-allocation/types";

interface SmartAllocationStatus {
  smartAllocation?: SmartAllocationTypes;
  loading: boolean;
  tableLoading: boolean;
  hasError: boolean;
}

const initialState: SmartAllocationStatus = {
  smartAllocation: undefined,
  loading: true,
  tableLoading: false,
  hasError: false,
};

const smartAllocationSlice = createSlice({
  name: "smart-allocation",
  initialState,
  reducers: {
    setSmartAllocation(
      state,
      action: PayloadAction<SmartAllocationTypes | undefined>,
    ) {
      state.smartAllocation = action.payload;
      state.loading = false;
      state.tableLoading = false;
      state.hasError = false;
    },
    toggleSALoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    toggleSATableLoadingLoading(state, action: PayloadAction<boolean>) {
      state.tableLoading = action.payload;
    },
    setSAHasError(state, action: PayloadAction<boolean>) {
      state.hasError = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase("clear", () => {
      return initialState;
    });
  },
});

export const {
  setSmartAllocation,
  toggleSALoading,
  toggleSATableLoadingLoading,
  setSAHasError
} = smartAllocationSlice.actions;
export default smartAllocationSlice.reducer;
